import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { queryInputReducer } from "./queryInputSlice";
import { QueryInput, getDefaultQueryInput } from "../schema/types/query/input";
import { Query } from "../schema/types/query/query";

interface ActiveState {
  value?: Query;
}

const activeSlice = createSlice({
  name: "active",
  initialState: { value: undefined } as ActiveState,
  reducers: {
    setActive: (state, action: PayloadAction<Query>) => {
      state.value = action.payload;
    },
    clearActive: (state) => {
      state.value = undefined;
    },
  },
});

export const { setActive, clearActive } = activeSlice.actions;

export const queryReducer = (
  state: any = { draft: queryInputReducer(getDefaultQueryInput(), { type: "" }), active: undefined },
  action: any,
) => {
  const newState = {
    draft: queryInputReducer(state.draft, action),
    active: state.active,
  };

  if (action.type === setActive.type) {
    newState.active = action.payload;
  } else if (action.type === clearActive.type) {
    newState.active = undefined;
  }

  return newState;
};

export const selectQuery = (state: { query: { draft: QueryInput; active?: Query } }) => state.query;
